import type { Mensagem } from '@/features/messaging';

export const getMensagemRecebidaAposEncerramento = ({
  isClosed,
  mensagemId,
  encerramentoData,
  mensagens,
}: {
  isClosed: boolean;
  mensagemId: string | null;
  encerramentoData: string | null;
  mensagens: Mensagem[];
}): Mensagem | null => {
  if (!isClosed || !mensagemId) return null;

  const mensagem = mensagens.find((item) => item.id === mensagemId);
  if (!mensagem || mensagem.direction !== 'INBOUND' || mensagem.tipo === 'SYSTEM') return null;

  if (encerramentoData) {
    const encerramentoTime = Date.parse(encerramentoData);
    const mensagemTime = Date.parse(mensagem.createdAt);
    if (!Number.isFinite(encerramentoTime) || !Number.isFinite(mensagemTime)) return null;
    if (mensagemTime <= encerramentoTime) return null;
  }

  const recebidaEm = Date.parse(mensagem.createdAt);
  const jaRespondida = mensagens.some((item) => {
    if (item.conversaId !== mensagem.conversaId || item.direction !== 'OUTBOUND') return false;
    if (!['SENT', 'DELIVERED', 'SEEN'].includes(item.status)) return false;
    const enviadaEm = Date.parse(item.createdAt);
    return Number.isFinite(recebidaEm) && Number.isFinite(enviadaEm) && enviadaEm > recebidaEm;
  });
  if (jaRespondida) return null;

  return mensagem;
};
